// extracted by mini-css-extract-plugin
export default {"headline":"Headline_headline__MUCFz"};